import { memo, useCallback } from 'react';
import { Input } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

/** Placeholder suggested from the address: "maria.lopez@x.com" -> "Maria". */
const suggestName = (email) => {
  const first = email.split('@')[0].split(/[._+-]/)[0];
  return first ? first[0].toUpperCase() + first.slice(1) : '';
};

/**
 * Optional display name of one recipient, next to its email.
 *
 * @param {object} props
 * @param {string} props.email
 * @param {string} [props.value]
 * @param {(email: string, name: string) => void} props.onChange
 */
function NameField({ email, value = '', onChange }) {
  const { t } = useTranslation('people-access');
  const handleChange = useCallback((event) => onChange(email, event.target.value), [email, onChange]);

  return (
    <div className="grid grid-cols-1 items-center gap-2 md:grid-cols-2">
      <span className="truncate text-sm text-content">{email}</span>
      <Input
        aria-label={t('invite.people.nameFor', { email })}
        placeholder={suggestName(email) || t('invite.people.namePlaceholder')}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
}

export default memo(NameField);
